import React from 'react'

export default function Thirdpage() {
  return (
    <div className='Third'>
      <div className='third-title'>
      <img style={{width: '350px', position: 'relative', height: '380px'}}  className=""src={require('/Users/macbook/metawork/src/assets/Group 5.png')} />  <br /> 
      </div>
      <div className='r'>
      <h1 className="n">TRAIN TO EARN</h1>
      <p className='o'>INCOME OPPORTUNITIES POWERED BY TRAINING NEXT-GENERATION AI</p>
      <p className='oo'>To earn income Scholars must complete training task in the form of gamified puzzles. <br />
       Successful completion of a puzzle provides the necessary data required for AI training, machine learning, natural language processing and more<br />
</p> <br /> <br />
       <button className='btn'>TRAIN TO EARN</button> 
      </div>
      <div>
      </div>
    </div>
  )
}

